import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CustomStatusesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ width: '32px', height: '32px' }} {...props}>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.0007 8.08325C11.6307 8.08325 8.08398 11.6299 8.08398 15.9999C8.08398 20.3699 11.6307 23.9166 16.0007 23.9166C20.3707 23.9166 23.9173 20.3699 23.9173 15.9999C23.9173 11.6299 20.3707 8.08325 16.0007 8.08325ZM12.0423 12.0416H17.584V13.6249H12.0423V12.0416ZM12.0423 14.4166H17.584V15.9999H12.0423V14.4166ZM14.4173 18.3749H12.0423V16.7916H14.4173V18.3749ZM17.6236 21.0349L15.3832 18.7945L16.4994 17.6783L17.6157 18.7945L20.4261 15.9999L21.5423 17.1162L17.6236 21.0349Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};

export default CustomStatusesIcon;
